<div class="email-tag-input-container" [class.focused]="isFocused" [class.has-error]="required && emails.length === 0">
  <div class="tags-container">
    <!-- Email Tags -->
    <span *ngFor="let email of emails; let i = index" class="email-tag">
      {{ email }}
      <button type="button" class="tag-remove" (click)="removeEmail(i)">×</button>
    </span>
    
    <!-- Input -->
    <input
      type="text"
      [(ngModel)]="inputValue"
      [placeholder]="emails.length === 0 ? placeholder : ''"
      (keydown)="onKeyDown($event)"
      (blur)="onBlur()"
      (focus)="isFocused = true"
      class="email-input"
      [ngModelOptions]="{standalone: true}"
    >
  </div>
</div>

<!-- Error Messages -->
<div *ngIf="showError" class="error-message">
  Please enter a valid email address
</div>
<div *ngIf="required && emails.length === 0" class="error-message">
  At least one email is required
</div>